interface getCollectionWallpapersTypes {
  id?: string;
  page: number;
  limit: number;
}

async function getCollectionWallpapers({
  id,
  page,
  limit,
}: getCollectionWallpapersTypes) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/collections-records/${id}?page=${page}&limit=${limit}`;

  const res = await fetch(url, { credentials: "include" });
  const collectionWallpapers = await res.json();

  return collectionWallpapers;
}

export default getCollectionWallpapers;
